@if (hasCourseCatalog()) {
	<md-content-box class="lesson-block" [type]="isObjectivesInvalid() ? 'error' : 'default'">
		<md-icon icon="untitled-ui/education/book-open-02"></md-icon>
		<div class="lesson-block__body">
			<div class="lesson-block__header">
				<md-header size="xs">
					Objectives
					<span md-tooltip="Required grade" class="required">*</span>
				</md-header>
			</div>

			<div class="lesson-block__content">
				@if (objectivesRemovedByProgramChange()) {
					<div class="objectives-removed-notice">
						<md-tag type="warning">Objectives not visible due to enrollment change. See notes.</md-tag>
					</div>
				}

				@if (savedObjectiveLabels().length > 0 && isLearnerExperience()) {
					<div class="saved-objectives">
						@for (obj of savedObjectiveLabels(); track obj.value) {
							<md-tag type="default">{{ obj.label }}</md-tag>
						}
					</div>
				}

				@if (!isReadOnly()) {
					<md-drop-down
						placeholder="Choose course objective(s) you worked towards"
						[multiple]="true"
						[disabled]="fieldsDisabled()"
						[options]="objectiveOptions()"
						[value]="selectedObjectives()"
						(change)="onObjectiveChange($event)"
					></md-drop-down>
				} @else {
					@if (selectedObjectives().length === 0 && savedObjectiveLabels().length === 0) {
						<span class="empty-state">No objectives recorded for this lesson.</span>
					}
				}
			</div>
		</div>
	</md-content-box>
}
